import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=7ff1822f&scoped=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PrivacyPolicyView.vue?vue&type=style&index=0&id=7ff1822f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1822f",
  null
  
)

export default component.exports